// Environment configuration object
// This file centralizes all API URLs and other environment-specific configurations

// ENVIRONMENT SELECTION
// Change this to switch between environments
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'local';
// const ENVIRONMENT = 'development';

// API URL CONFIGURATIONS FOR DIFFERENT ENVIRONMENTS
const ENV_CONFIG = {  
  local: {
    API_URL: process.env.REACT_APP_BASE_URL_LOCAL ,
    WS_URL: process.env.REACT_APP_SOCKET_LOCAL_URL ,
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL_LOCAL ,
  },
  development: {    
    API_URL: process.env.REACT_APP_BASE_URL_DEV,
    WS_URL: process.env.REACT_APP_SOCKET_DEV_URL,
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL_DEV,
  },
  production: {
    API_URL: process.env.REACT_APP_BASE_URL_PROD, 
    WS_URL: process.env.REACT_APP_SOCKET_PROD_URL,
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL_PROD,
  },
  // Add other environments if needed
};

// Get the configuration for the selected environment
const getCurrentEnvConfig = () => {
  // Fallback to development if the specified environment doesn't exist
  if (!ENV_CONFIG[ENVIRONMENT]) {
    console.warn(`Environment "${ENVIRONMENT}" not found! Using development environment instead.`);
    return ENV_CONFIG.production;
  }
  return ENV_CONFIG[ENVIRONMENT];
};

// Export the configuration values
export const { API_URL, WS_URL, FRONTEND_URL } = getCurrentEnvConfig();

// For backward compatibility with existing code that uses API_BASE_URL
export const API_BASE_URL = API_URL;

// Function to ensure API URL has correct format (ends with '/' or not)
export const getFormattedApiUrl = (shouldEndWithSlash = false) => {
  if (shouldEndWithSlash) {
    return API_URL.endsWith('/') ? API_URL : `${API_URL}/`;
  } else {
    return API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
  }
};

// WebSocket URL builder function
export const getWebSocketUrl = (endpoint) => {
  // Remove any leading slash from endpoint to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  // Convert HTTP/HTTPS to WS/WSS protocol
  let baseUrl = WS_URL;
  if (baseUrl.startsWith('https://')) {
    baseUrl = baseUrl.replace('https://', 'wss://');
  } else if (baseUrl.startsWith('http://')) {
    baseUrl = baseUrl.replace('http://', 'ws://');
  }
  
  // Remove trailing /ws/ or /ws from baseUrl since the endpoint already includes ws or ws-gamified
  // This prevents duplication like /ws/ws-gamified/...
  baseUrl = baseUrl.replace(/\/ws\/?$/, '');
  
  // Ensure baseUrl ends with a single slash
  baseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  
  const finalUrl = `${baseUrl}${cleanEndpoint}`;
  
  // Debug logging to help verify URL construction
  if (process.env.NODE_ENV === 'development') {
    console.log('WebSocket URL construction:', {
      originalWS_URL: WS_URL,
      convertedBaseUrl: baseUrl,
      originalEndpoint: endpoint,
      cleanEndpoint,
      finalUrl
    });
  }
  
  return finalUrl;
};
